export default "__VITE_ASSET__D97F50WN__"